import helloWorldBody from './hello-world';
import gettingTheInsideOutBody from './getting-the-inside-out';

export const posts = [
  {
    slug: 'hello-world',
    title: 'Hello, world',
    date: '2026-05-30',
    summary: 'A first post — what this blog is for and what to expect.',
    body: helloWorldBody,
  },
  {
    slug: 'getting-the-inside-out',
    title: 'Getting the Inside Out',
    date: '2026-06-14',
    summary: 'On why everyday beauty resonates — and the artist’s job of bringing an inner view into the world.',
    body: gettingTheInsideOutBody,
  },
].sort((a, b) => b.date.localeCompare(a.date));

export function getPost(slug) {
  return posts.find((p) => p.slug === slug);
}
